import React, { Component, Suspense } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import Jaki from "./../../../images/jaki-cat.png";
import i18n from "i18next";
import * as EmailValidator from "email-validator";
import { DebounceInput } from "react-debounce-input";
import Script from "react-load-script";
import { ToastContainer, toast } from "react-toastify";
import { Map, InfoWindow, Polygon, GoogleApiWrapper } from "google-maps-react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "./ProgramDetail.scss";
import { withTranslation, Translation } from "react-i18next";

function debounce(func, wait, immediate) {
   var timeout;
   return function () {
      var context = this,
         args = arguments;
      var later = function () {
         timeout = null;
         if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
   };
}

function SeparatorValue(lang, value) {
   var val;
   if (value >= 1000000) {
      val = value / 1000000;
   } else if (value >= 999.999 && value < 1000000) {
      val = value / 1000;
   } else {
      val = value;
   }
   if (lang === "en") {
      if (value >= 1000000) {
         return (
            <React.Fragment>
               <NumberFormat
                  value={val}
                  displayType={"text"}
                  thousandSeparator={","}
                  decimalSeparator={"."}
                  decimalScale={1}
               />
            </React.Fragment>
         );
      } else if (value >= 999.999 && value < 1000000) {
         return (
            <React.Fragment>
               <NumberFormat
                  value={val}
                  displayType={"text"}
                  thousandSeparator={","}
                  decimalSeparator={"."}
                  decimalScale={1}
               />
            </React.Fragment>
         );
      } else {
         return (
            <React.Fragment>
               <NumberFormat
                  value={val}
                  displayType={"text"}
                  thousandSeparator={","}
                  decimalSeparator={"."}
                  decimalScale={0}
               />
            </React.Fragment>
         );
      }
   } else {
      if (value >= 1000000) {
         return (
            <React.Fragment>
               <NumberFormat
                  value={val}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={1}
               />
            </React.Fragment>
         );
      } else if (value >= 999.999 && value < 1000000) {
         return (
            <React.Fragment>
               <NumberFormat
                  value={val}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={1}
               />
            </React.Fragment>
         );
      } else {
         return (
            <React.Fragment>
               <NumberFormat
                  value={val}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  decimalScale={0}
               />
            </React.Fragment>
         );
      }
   }
}
function UnitValue(lang, value) {
   if (lang === "en") {
      if (value <= 999.999) {
         return "grams";
      } else if (value <= 1000000) {
         return "kg";
      } else {
         return "tonnes";
      }
   } else {
      if (value <= 999.999) {
         return "gram";
      } else if (value <= 1000000) {
         return "kg";
      } else {
         return "ton";
      }
   }
}

const mapStyle = [
   {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
         {
            color: "#dceafa",
         },
      ],
   },
];
class ProgramDetailTree extends Component {
   constructor(props) {
      super(props);
      this.state = {
         lang: null,
         loaderButton: false,
         loggedIn: false,
         loading: true,
         userFootprint: false,
         total_carbon: 0,
         userType: 0,
         programId: null,
         program: [],
         featuredImage: null,
         programImages: null,
         treeQty: 1,
         bounds: null,
         showingInfoWindow: false,
         activeMarker: {},
         selectedPlace: {},
         verifiedUser: null,
         checkOptTreeSpecies: 0,
         selectedTreeName: null,
         selectedTreeSummaryId: null,
         selectedTotal: null,
         selectedAvailable: null,
         selectedPrice: null,
         selectedIncludeTax: true,
         selectedAddedTaxPercentage: null,
         selectedPaymentType: 2,
         plusActive: true,
         minusActive: false,
         hitGetActions: 0,
         scriptLoaded: null,
         scriptError: null,
         modalConfirmation: false,
         checked: false,
         fullName: null,
         fullNameValid: false,
         fullNameAlert: null,
         email: null,
         emailValid: false,
         emailAlert: null,
         phone: "",
         transactionCarbon: 0,
      };
      this.inputChangedHandler = this.inputChangedHandler.bind(this);
   }

   handleChangeEmail = (e) => {
      this.setState(
         {
            email: e.target.value,
         },
         () => {
            let emailValid = EmailValidator.validate(this.state.email);
            console.log("emailValid is ", emailValid);
            if (emailValid) {
               this.setState({
                  emailValid: true,
               });
            } else {
               this.setState({
                  emailValid: false,
                  emailAlert: i18n.t("PlaseInputValidEmail"),
               });
            }
         }
      );
   };

   handleChangeName = (e) => {
      if (e.target.value.length < 3) {
         this.setState({
            fullName: e.target.value,
            fullNameValid: false,
            fullNameAlert: i18n.t("PlaseInputThreeChar"),
         });
      } else {
         this.setState({
            fullNameValid: true,
            fullName: e.target.value,
         });
      }
   };

   handleCheckClick = () => {
      this.setState({ checked: !this.state.checked });
   };

   cancelOrderTree = (idorder) => {
      console.log("cancel order");
      var configHeader = {
         headers: {
            "Content-Type": "application/json",
         },
      };
      axios({
         method: "PUT",
         url:
            process.env.REACT_APP_API_HOST +
            "/order/tree/new/cancel/" +
            idorder,
         headers: {
            "Content-Type": "application/json",
         },
      }).then(
         (res) => {
            console.log("res cancel tree ", res.data);
            if (res.data.status) {
               console.log("cancel order success ");
               setTimeout(() => {
                  this.getProgramDetail(this.state.programId, configHeader);
               }, 1000);
            }
         },
         (error) => {
            setTimeout(() => {
               toast.error("Error! " + error);
               setTimeout(() => {
                  this.getProgramDetail(this.state.programId, configHeader);
               }, 1000);
            }, 1000);
         }
      );
   };
   handleScriptCreate() {
      this.setState({ scriptLoaded: false });
   }
   handleScriptError() {
      this.setState({ scriptError: true });
   }
   handleScriptLoad() {
      this.setState({ scriptLoaded: true });
   }
   changeTreeSpecies = (e) => {
      console.log("tree species index ", e.target.value);
      this.setState({
         checkOptTreeSpecies: e.target.value,
         selectedTreeName:
            this.state.program.treeSummaries[e.target.value].treeName,
         selectedTreeSummaryId:
            this.state.program.treeSummaries[e.target.value].id,
         selectedTotal: this.state.program.treeSummaries[e.target.value].total,
         selectedAvailable:
            this.state.program.treeSummaries[e.target.value].available,
         selectedPrice:
            this.state.program.treeSummaries[e.target.value].sellingPrice,
         selectedIncludeTax:
            this.state.program.treeSummaries[e.target.value].includeTax,
         selectedAddedTaxPercentage:
            this.state.program.treeSummaries[e.target.value].addedTaxPercentage,
         treeQty: 1,
         minusActive: false,
         plusActive: true,
      });
   };
   onDown = (e) => {
      e.preventDefault();
      this.setState({ treeQty: this.state.treeQty - 1 });
   };
   onUp = (e) => {
      e.preventDefault();
      this.setState({ treeQty: this.state.treeQty + 1 });
   };
   onPolygonClicked = (props, marker, e) => {
      this.setState({
         selectedPlace: props,
         activeMarker: marker,
         showingInfoWindow: true,
      });
   };
   onMapClicked = (props) => {
      if (this.state.showingInfoWindow) {
         this.setState({
            showingInfoWindow: false,
            activeMarker: null,
         });
      }
   };
   onInfoWindowClose = (props) => {
      this.setState({
         showingInfoWindow: false,
         activeMarker: null,
      });
   };
   onInfoWindowOpen = (props) => {};

   getActionsByIdOrder = debounce((programid, idorder) => {
      axios({
         method: "GET",
         url: process.env.REACT_APP_API_HOST + "/order/actions/" + idorder,
         headers: {
            "Content-Type": "application/json",
         },
      }).then(
         (res) => {
            console.log("res.data actions ", res.data);
            if (res.data.status) {
               if (res.data.data.token) {
                  this.setState({ modalConfirmation: false });
                  window.snap.pay(res.data.data.token, {
                     // Optional
                     onSuccess: function (result) {
                        /* You may add your own js here, this is just example */

                        console.log("onSuccess ", result);
                        if (result.status_code === "200") {
                           setTimeout(function () {
                              window.location.href =
                                 "/order/tree?order_id=" +
                                 res.data.data.orderId;
                           }, 1000);
                        }
                     },
                     // Optional
                     onPending: function (result) {
                        /* You may add your own js here, this is just example */
                        console.log("onPending ", result);
                        setTimeout(function () {
                           window.location.href =
                              "/order/tree?order_id=" + res.data.data.orderId;
                        }, 1000);
                     },
                     // Optional
                     onError: function (result) {
                        /* You may add your own js here, this is just example */

                        console.log("customer onError ", result);
                        toast.error("Error, Pembayaran kamu terjadi kegagalan");
                     },
                     onClose: function (result) {
                        console.log(
                           "customer closed the popup without finishing the payment",
                           result
                        );
                        console.log("order id ", res.data.data.id);
                        // cancelOrderTree(res.data.data.orderId)
                        setTimeout(function () {
                           window.location.href =
                              "/program/tree?id=" +
                              programid +
                              "&cancel=" +
                              res.data.data.id +
                              "&" +
                              window.location.href.split("?")[1];
                        }, 100);
                     },
                  });
               }
            } else {
               if (this.state.hitGetActions < 60) {
                  // call again
                  console.log("call again getactions ");
                  this.setState(
                     { hitGetActions: this.state.hitGetActions + 1 },
                     () =>
                        this.getActionsByIdOrder(this.state.programId, idorder)
                  );
               } else {
                  // error
                  setTimeout(() => {
                     this.setState({
                        loaderButton: false,
                        errorState: true,
                        error: "Sorry, something went wrong.",
                     });
                  }, 1000);
               }
            }
         },
         (error) => {}
      );
   }, 1500);

   confirmBuyTree = (index) => {
      this.setState({ modalConfirmation: true });
   };

   buyTree = (e) => {
      e.preventDefault();
      this.setState({ loaderButton: true });
      let data = {
         programId: this.state.program.id,
         totalTree: this.state.treeQty,
         paymentType: this.state.selectedPaymentType,
         treeSummaryId: this.state.selectedTreeSummaryId,
      };
      axios({
         method: "POST",
         url: process.env.REACT_APP_API_HOST + "/order/tree/add",
         headers: {
            "Content-Type": "application/json",
            token: JSON.parse(localStorage.getItem("userData")).token,
         },
         data: data,
      }).then(
         (res) => {
            // console.log("res buy tree ", res.data);
            if (res.data.status) {
               if (this.state.selectedPaymentType === 0) {
                  setTimeout(function () {
                     window.location.href =
                        "/payment/tree/status/" + res.data.data.id;
                  }, 1000);
               } else {
                  this.getActionsByIdOrder(
                     this.state.program.id,
                     res.data.data.id
                  );
               }
            } else {
               setTimeout(() => {
                  this.setState({
                     loaderButton: false,
                     errorState: true,
                     error: "Sorry, something went wrong.",
                  });
               }, 1000);
            }
         },
         (error) => {
            setTimeout(() => {
               toast.error("Error! " + error);
               this.setState({ loaderButton: false });
            }, 1000);
         }
      );
   };

   orderTree = (e) => {
      console.log("Ordering...");
      this.setState({ loaderButton: true });
      let data = {
         fullName: this.state.fullName,
         email: this.state.email,
         lang: window.localStorage.i18nextLng,
         utm: window.location.href,
         totalCarbon: this.state.total_carbon / 1000000,
         totalTree: this.state.treeQty,
         programId: this.state.program.id,
         treeSummaryId: this.state.selectedTreeSummaryId,
         paymentType: this.state.selectedPaymentType,
      };
      axios({
         method: "POST",
         url: process.env.REACT_APP_API_HOST + "/order/tree/new",
         headers: {
            "Content-Type": "application/json",
         },
         data: data,
      }).then(
         (res) => {
            // console.log("res buy tree ", res.data);
            if (res.data.status) {
               if (this.state.selectedPaymentType === 0) {
                  setTimeout(function () {
                     window.location.href =
                        "/payment/tree/status/" + res.data.data.id;
                  }, 1000);
               } else {
                  this.getActionsByIdOrder(
                     this.state.program.id,
                     res.data.data.id
                  );
               }
            } else {
               if (res.data.errors.length) {
                  for (var er = 0; er < res.data.errors.length; er++) {
                     var obj = res.data.errors[er];
                     for (var key in obj) {
                        console.log(key, obj[key]);
                        toast.error(i18n.t(obj[key]));
                     }
                     this.setState({ loaderButton: false });
                  }
               } else {
                  this.setState({ loaderButton: false });
                  toast.error(res.data.errors);
               }
            }
         },
         (error) => {
            setTimeout(() => {
               toast.error("Error! " + error);
               this.setState({ loaderButton: false });
            }, 1000);
         }
      );
   };

   inputChangedHandler(x) {
      // console.log("x ", x);
      if (x.floatValue !== undefined) {
         if (x.floatValue > this.state.selectedAvailable) {
            this.setState({
               treeQty: this.state.selectedAvailable,
               plusActive: false,
               minusActive: true,
            });
         } else if (x.floatValue === this.state.selectedAvailable) {
            this.setState({
               treeQty: x.floatValue,
               plusActive: false,
               minusActive: true,
            });
         } else if (x.floatValue === 0) {
            this.setState({ treeQty: 1, minusActive: false, plusActive: true });
         } else if (x.floatValue === 1) {
            this.setState({
               treeQty: x.floatValue,
               minusActive: false,
               plusActive: true,
            });
         } else {
            this.setState({ treeQty: x.floatValue, minusActive: true });
         }
      }
   }
   onImageClick = (props) => {
      let tag = props.currentTarget.dataset.img;
      this.setState({ featuredImage: tag });
   };
   makeBounds = () => {
      var points = this.state.program.blockPolygon;
      var bounds = new this.props.google.maps.LatLngBounds();
      for (var i = 0; i < points.length; i++) {
         bounds.extend(points[i]);
      }
      this.setState({ bounds });
   };
   componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const programId = query.get("id");
      const cancelOrder = query.get("cancel");
      const total_carbon = query.get("total_carbon");
      // console.log("cancelOrder ", cancelOrder);
      // console.log("lang is ", window.localStorage.i18nextLng);
      const userData = localStorage.getItem("userData");
      this.setState({
         loggedIn: false,
         programId: programId,
         lang: window.localStorage.i18nextLng,
      });
      if (total_carbon) {
         this.setState({ userFootprint: true, total_carbon: total_carbon });
      } else {
         this.setState({ userFootprint: false, total_carbon: 0 });
      }
      if (userData) {
         var configHeader = {
            headers: {
               "Content-Type": "application/json",
               token: JSON.parse(localStorage.getItem("userData")).token,
            },
         };
         if (JSON.parse(userData).data.userType === 0) {
            // Personal
            this.setState({
               loggedIn: true,
               verifiedUser: JSON.parse(userData).data.verified,
               userType: JSON.parse(userData).data.userType,
               selectedPaymentType: 2,
            });
         } else {
            // Business
            this.setState({
               loggedIn: true,
               verifiedUser: JSON.parse(userData).data.verified,
               userType: JSON.parse(userData).data.userType,
               selectedPaymentType: 0,
            });
         }
         const cancelSummary = new String(cancelOrder);
         console.log("cancel summary..", cancelSummary);
         console.log("cancel summary length..", cancelSummary.length);
         if (
            cancelOrder &&
            cancelSummary.length > 30 &&
            cancelSummary.length < 38
         ) {
            this.cancelOrderTree(cancelSummary);
         } else {
            this.getProgramDetail(programId, configHeader);
         }
      } else {
         var configHeader = {
            headers: {
               "Content-Type": "application/json",
            },
         };
         const cancelSummary = new String(cancelOrder);
         console.log("cancel summary..", cancelSummary);
         console.log("cancel summary length..", cancelSummary.length);
         if (
            cancelOrder &&
            cancelSummary.length > 30 &&
            cancelSummary.length < 38
         ) {
            this.cancelOrderTree(cancelSummary);
         }
         this.getProgramDetail(programId, configHeader);
      }
   }

   getProgramDetail = (programId, configHeader) => {
      axios
         .get(
            process.env.REACT_APP_API_HOST +
               "/program/detail/tree/" +
               programId,
            configHeader
         )
         .then((res) => {
            // console.log("res program is ", res.data);
            this.setState({
               program: res.data.data,
               programImages: res.data.data.programImages,
               featuredImage: res.data.data.featuredImage,
               treeQty: 1,
               loading: false,
               programId: programId,
               selectedTreeName: res.data.data.treeSummaries[0].treeName,
               selectedTreeSummaryId: res.data.data.treeSummaries[0].id,
               selectedTotal: res.data.data.treeSummaries[0].total,
               selectedAvailable: res.data.data.treeSummaries[0].available,
               selectedPrice: res.data.data.treeSummaries[0].sellingPrice,
               selectedIncludeTax: res.data.data.treeSummaries[0].includeTax,
               selectedAddedTaxPercentage:
                  res.data.data.treeSummaries[0].addedTaxPercentage,
            });
         });
   };
   _mapLoaded(mapProps, map) {
      this.makeBounds();
      // console.log("map. ", map);
      map.setOptions({
         styles: mapStyle,
         mapTypeControl: false,
         mapTypeId: "satellite",
      });
   }

   render() {
      const data = this.state.program;
      let buyButton;
      if (this.state.loggedIn) {
         if (this.state.verifiedUser === true) {
            buyButton = (
               <button
                  className='btn btn-orange btn-block'
                  onClick={() => {
                     this.confirmBuyTree();
                  }}
               >
                  {this.props.t("ProgramDetailTree.btn_beli")}
               </button>
            );
         } else {
            buyButton = (
               <Link to='/profile' className='btn btn-orange btn-block'>
                  {this.props.t("ProgramDetailTree.btn_verify")}
               </Link>
            );
         }
      } else {
         buyButton = (
            <Link to='/login' className='btn btn-orange btn-block text-center'>
               {this.props.t("ProgramDetailTree.btn_login")}
            </Link>
         );
      }

      let buttonPayment;
      if (this.state.fullNameValid && this.state.emailValid) {
         buttonPayment = (
            <div>
               {this.state.loaderButton === true ? (
                  <button
                     className='btn btn-orange btn-block tx-medium tx-center tx-uppercase btn-disabled'
                     disabled
                  >
                     <div className='loader'></div>
                  </button>
               ) : (
                  <React.Fragment>
                     <button
                        className='btn btn-orange btn-block tx-medium tx-uppercase'
                        onClick={this.confirmBuyTree}
                     >
                        <Translation>
                           {(t, { i18n }) => (
                              <React.Fragment>
                                 {t("TransactionsTree.btn_bayar")}
                              </React.Fragment>
                           )}
                        </Translation>
                     </button>
                  </React.Fragment>
               )}
            </div>
         );
      } else {
         buttonPayment = (
            <button className='btn btn-block tx-medium tx-uppercase'>
               <Translation>
                  {(t, { i18n }) => (
                     <React.Fragment>
                        {t("TransactionsTree.btn_bayar")}
                     </React.Fragment>
                  )}
               </Translation>
            </button>
         );
      }
      return (
         <div className='mpl-page cp-85'>
            <Script
               url={process.env.REACT_APP_SNAP}
               attributes={{
                  "data-client-key": process.env.REACT_APP_CLIENT_KEY,
               }}
               onCreate={this.handleScriptCreate.bind(this)}
               onError={this.handleScriptError.bind(this)}
               onLoad={this.handleScriptLoad.bind(this)}
            />
            <ToastContainer autoClose={1500} />
            {this.state.loading === true ? (
               <div className='text-center'>
                  <div
                     className='loader'
                     style={{
                        height: "24px",
                        width: "24px",
                        borderColor: "#00880d",
                        borderTopColor: "#ddd",
                        margin: "auto",
                     }}
                  ></div>
               </div>
            ) : (
               <div>
                  <Suspense fallback={"...Loading"}>
                     <Translation>
                        {(t) => (
                           <>
                              <div className='container'>
                                 <div className='row'>
                                    {/* Image */}
                                    <div className='col-sm-12'>
                                       {this.state.userFootprint ? (
                                          <>
                                             <div
                                                className='box-calc-emission'
                                                style={{ marginBottom: "25px" }}
                                             >
                                                <span>
                                                   {t(
                                                      "YourTotalCarbonFootprint"
                                                   )}
                                                </span>
                                                <img src={Jaki} alt='Jejakin' />
                                                <h2 className='mb-0'>
                                                   {this.state.lang === "id" ? (
                                                      <React.Fragment>
                                                         <NumberFormat
                                                            value={parseFloat(
                                                               this.state
                                                                  .total_carbon
                                                            )}
                                                            displayType={"text"}
                                                            thousandSeparator={
                                                               "."
                                                            }
                                                            decimalSeparator={
                                                               ","
                                                            }
                                                            decimalScale={0}
                                                         />{" "}
                                                         gram
                                                      </React.Fragment>
                                                   ) : (
                                                      <React.Fragment>
                                                         <NumberFormat
                                                            value={parseFloat(
                                                               this.state
                                                                  .total_carbon
                                                            )}
                                                            displayType={"text"}
                                                            thousandSeparator={
                                                               ","
                                                            }
                                                            decimalSeparator={
                                                               "."
                                                            }
                                                            decimalScale={0}
                                                         />{" "}
                                                         grams
                                                      </React.Fragment>
                                                   )}
                                                </h2>
                                             </div>
                                          </>
                                       ) : null}
                                       <img
                                          id='expandedImg'
                                          className='imageProgram'
                                          src={
                                             process.env.REACT_APP_IMG_PATH +
                                             `/deo-query/image/program/${this.state.featuredImage}`
                                          }
                                          alt='Featured Image'
                                       />
                                       <div className='row row-narrow mt-3'>
                                          {data.programImages.map(
                                             (item, idx) => {
                                                if (idx < 3) {
                                                   return (
                                                      <div
                                                         className='col-4 mb-3'
                                                         key={item}
                                                      >
                                                         <div className='column'>
                                                            <img
                                                               src={
                                                                  process.env
                                                                     .REACT_APP_IMG_PATH +
                                                                  `/deo-query/image/program/${item}`
                                                               }
                                                               alt='Jejak'
                                                               data-img={item}
                                                               className='rounded-img'
                                                               onClick={
                                                                  this
                                                                     .onImageClick
                                                               }
                                                            />
                                                         </div>
                                                      </div>
                                                   );
                                                }
                                             }
                                          )}
                                       </div>
                                    </div>

                                    {/* Detail */}
                                    <div className='col-sm-12'>
                                       <h2 className='title-page mt-0 mb-2'>
                                          {data.title}
                                       </h2>
                                       {data.minPrice === data.maxPrice ? (
                                          <h2 className='price-page text-orange text-bold mt-1 mb-2'>
                                             Rp{" "}
                                             <NumberFormat
                                                value={data.priceRange}
                                                displayType={"text"}
                                                decimalScale={0}
                                                thousandSeparator={","}
                                                decimalSeparator={"."}
                                             />
                                          </h2>
                                       ) : (
                                          <h2 className='price-page text-orange text-bold mt-1 mb-2'>
                                             Rp{" "}
                                             <NumberFormat
                                                value={data.minPrice}
                                                displayType={"text"}
                                                decimalScale={0}
                                                thousandSeparator={","}
                                                decimalSeparator={"."}
                                             />{" "}
                                             -{" "}
                                             <NumberFormat
                                                value={data.maxPrice}
                                                displayType={"text"}
                                                decimalScale={0}
                                                thousandSeparator={","}
                                                decimalSeparator={"."}
                                             />
                                          </h2>
                                       )}

                                       <div className='program-text-small mb-2 text-bold'>
                                          per{" "}
                                          {this.props.t(
                                             "ProgramDetailTree.w_pohon"
                                          )}
                                       </div>
                                       <br />
                                       <div className='program-text-small mb-2'>
                                          <div className='row'>
                                             <div className='col-auto'>
                                                <div
                                                   style={{ width: "70px" }}
                                                   className='text-gray text-uppercase'
                                                >
                                                   {this.props.t(
                                                      "ProgramDetailTree.w_penjual"
                                                   )}
                                                </div>
                                             </div>
                                             <div className='col-auto'>
                                                <span className='text-bold'>
                                                   {data.corporateName}
                                                </span>
                                             </div>
                                          </div>
                                       </div>
                                       <div className='program-text-small mb-4'>
                                          <div className='row'>
                                             <div className='col-auto'>
                                                <div
                                                   style={{ width: "70px" }}
                                                   className='text-gray text-uppercase'
                                                >
                                                   {this.props.t(
                                                      "ProgramDetailTree.w_lokasi"
                                                   )}
                                                </div>
                                             </div>
                                             <div className='col-auto'>
                                                <span className='text-bold'>
                                                   {data.province}
                                                </span>
                                             </div>
                                          </div>
                                       </div>
                                       <hr className='line-div' />
                                       <div className='program-text-small mb-4'>
                                          <div className='row align-items-center'>
                                             <div className='col-auto'>
                                                <div
                                                   style={{ width: "70px" }}
                                                   className='text-gray text-uppercase'
                                                >
                                                   {this.props.t(
                                                      "ProgramDetailTree.w_spesies"
                                                   )}
                                                </div>
                                             </div>
                                             <div className='col-auto'>
                                                <div className='form-group mb-0'>
                                                   <select
                                                      name='spesies'
                                                      id='treeSpesies'
                                                      className='field-group text-bold'
                                                      onChange={
                                                         this.changeTreeSpecies
                                                      }
                                                      value={
                                                         this.state
                                                            .checkOptTreeSpecies
                                                      }
                                                   >
                                                      {data.treeSummaries.map(
                                                         (item, index) => (
                                                            <option
                                                               value={index}
                                                               key={index}
                                                            >
                                                               {item.treeName} (
                                                               {item.available})
                                                            </option>
                                                         )
                                                      )}
                                                   </select>
                                                </div>
                                             </div>
                                          </div>
                                       </div>

                                       <div className='program-text-small mb-4'>
                                          <div className='row align-items-center'>
                                             <div className='col-auto'>
                                                <div
                                                   style={{ width: "70px" }}
                                                   className='text-gray text-uppercase'
                                                >
                                                   {this.props.t(
                                                      "ProgramDetailTree.w_carbon"
                                                   )}
                                                </div>
                                             </div>
                                             <div className='col-auto'>
                                                <div className='form-group mb-0'>
                                                   <h3>
                                                      {SeparatorValue(
                                                         this.state.lang,
                                                         data.treeSummaries[
                                                            this.state
                                                               .checkOptTreeSpecies
                                                         ].carbonPerTree *
                                                            1000000
                                                      )}{" "}
                                                      {UnitValue(
                                                         this.state.lang,
                                                         data.treeSummaries[
                                                            this.state
                                                               .checkOptTreeSpecies
                                                         ].carbonPerTree *
                                                            1000000
                                                      )}
                                                      &nbsp;
                                                      {this.props.t(
                                                         "ProgramDetailTree.w_sequestration"
                                                      )}
                                                   </h3>
                                                </div>
                                             </div>
                                          </div>
                                       </div>

                                       <div className='text-small text-gray text-uppercase mb-2'>
                                          {this.props.t(
                                             "ProgramDetailTree.w_ketersediaan"
                                          )}
                                       </div>
                                       <div className='progress-bar progress-available mb-2'>
                                          <div
                                             className='progress-green'
                                             style={{
                                                width: `${
                                                   ((data.treeSummaries[
                                                      this.state
                                                         .checkOptTreeSpecies
                                                   ].total -
                                                      data.treeSummaries[
                                                         this.state
                                                            .checkOptTreeSpecies
                                                      ].available) *
                                                      100) /
                                                   data.treeSummaries[
                                                      this.state
                                                         .checkOptTreeSpecies
                                                   ].total
                                                }%`,
                                             }}
                                          >
                                             {" "}
                                             &nbsp;
                                          </div>
                                       </div>
                                       <div className='row'>
                                          <div className='col'>
                                             <div
                                                className='text-bold mt-1'
                                                style={{
                                                   fontSize: "20px",
                                                   lineHeight: "24px",
                                                }}
                                             >
                                                <NumberFormat
                                                   value={
                                                      data.treeSummaries[
                                                         this.state
                                                            .checkOptTreeSpecies
                                                      ].total -
                                                      data.treeSummaries[
                                                         this.state
                                                            .checkOptTreeSpecies
                                                      ].available
                                                   }
                                                   displayType={"text"}
                                                   decimalScale={0}
                                                   thousandSeparator={","}
                                                   decimalSeparator={"."}
                                                />
                                             </div>
                                             {/* <span className="text-small text-gray">
                              {this.props.t("ProgramDetailTree.w_pohon")}
                           </span> */}
                                          </div>
                                          <div className='col'>
                                             <div className='float-right'>
                                                <div
                                                   className='text-bold mt-1'
                                                   style={{
                                                      fontSize: "20px",
                                                      lineHeight: "24px",
                                                   }}
                                                >
                                                   <NumberFormat
                                                      value={
                                                         data.treeSummaries[
                                                            this.state
                                                               .checkOptTreeSpecies
                                                         ].total
                                                      }
                                                      displayType={"text"}
                                                      decimalScale={0}
                                                      thousandSeparator={","}
                                                      decimalSeparator={"."}
                                                   />
                                                </div>
                                                <span className='text-small text-capitalize text-gray'>
                                                   {this.props.t(
                                                      "ProgramDetailTree.w_kapasitas"
                                                   )}
                                                </span>
                                             </div>
                                          </div>
                                       </div>
                                       <hr className='line-div' />
                                       {this.state.selectedAvailable === 0 ? (
                                          <div className='sold-out font-bold'>
                                             {this.props.t(
                                                "ProgramDetailTree.text_habisTerjual"
                                             )}
                                          </div>
                                       ) : (
                                          <div className='box-buy'>
                                             <div className='row'>
                                                <div className='col-md-12 col-lg-6'>
                                                   <div className='form-group'>
                                                      <label
                                                         className='label-group'
                                                         htmlFor='qty'
                                                      >
                                                         {this.props.t(
                                                            "ProgramDetailTree.text_jumlahPohon"
                                                         )}
                                                      </label>
                                                      <div className='row no-gutters'>
                                                         <div className='col-auto'>
                                                            {this.state
                                                               .minusActive ? (
                                                               <button
                                                                  className='btn btn-tree btn-down btn-green btn-block'
                                                                  onClick={
                                                                     this.onDown
                                                                  }
                                                               >
                                                                  <i className='fa fa-minus'></i>
                                                               </button>
                                                            ) : (
                                                               <button className='btn btn-disabled btn-tree btn-down btn-green btn-block'>
                                                                  <i className='fa fa-minus'></i>
                                                               </button>
                                                            )}
                                                         </div>
                                                         <div className='col-auto'>
                                                            {this.state
                                                               .selectedAvailable ===
                                                            0 ? (
                                                               <NumberFormat
                                                                  id='qty'
                                                                  name='qty'
                                                                  decimalScale={
                                                                     0
                                                                  }
                                                                  thousandSeparator={
                                                                     ","
                                                                  }
                                                                  decimalSeparator={
                                                                     "."
                                                                  }
                                                                  allowNegative={
                                                                     false
                                                                  }
                                                                  className='field-group tree-buy text-bold'
                                                                  disabled
                                                                  value={"0"}
                                                               />
                                                            ) : (
                                                               <NumberFormat
                                                                  id='qty'
                                                                  name='qty'
                                                                  decimalScale={
                                                                     0
                                                                  }
                                                                  thousandSeparator={
                                                                     ","
                                                                  }
                                                                  decimalSeparator={
                                                                     "."
                                                                  }
                                                                  allowNegative={
                                                                     false
                                                                  }
                                                                  className='field-group tree-buy text-bold'
                                                                  onValueChange={
                                                                     this
                                                                        .inputChangedHandler
                                                                  }
                                                                  value={
                                                                     this.state
                                                                        .treeQty
                                                                  }
                                                               />
                                                            )}
                                                         </div>
                                                         <div className='col-auto'>
                                                            {this.state
                                                               .plusActive ? (
                                                               <React.Fragment>
                                                                  {this.state
                                                                     .selectedAvailable ===
                                                                  0 ? (
                                                                     <button className='btn btn-disabled btn-tree btn-up btn-green btn-block'>
                                                                        <i className='fa fa-plus'></i>
                                                                     </button>
                                                                  ) : (
                                                                     <button
                                                                        className='btn btn-tree btn-up btn-green btn-block'
                                                                        onClick={
                                                                           this
                                                                              .onUp
                                                                        }
                                                                     >
                                                                        <i className='fa fa-plus'></i>
                                                                     </button>
                                                                  )}
                                                               </React.Fragment>
                                                            ) : (
                                                               <button className='btn btn-disabled btn-tree btn-up btn-green btn-block'>
                                                                  <i className='fa fa-plus'></i>
                                                               </button>
                                                            )}
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                                <div className='col-md-12 col-lg-6'>
                                                   <div className='form-group'>
                                                      <label
                                                         className='label-group'
                                                         htmlFor='totalPrice'
                                                      >
                                                         {this.props.t(
                                                            "ProgramDetailTree.text_totalHarga"
                                                         )}
                                                      </label>
                                                      <NumberFormat
                                                         id='totalPrice'
                                                         name='totalPrice'
                                                         prefix={"Rp "}
                                                         decimalScale={0}
                                                         thousandSeparator={","}
                                                         decimalSeparator={"."}
                                                         className='field-group text-bold'
                                                         value={
                                                            this.state
                                                               .selectedPrice *
                                                            this.state.treeQty
                                                         }
                                                         disabled
                                                      />
                                                   </div>
                                                </div>
                                             </div>

                                             <div className='form-group mb-2'>
                                                {this.state
                                                   .selectedAvailable === 0 ? (
                                                   <React.Fragment>
                                                      <button
                                                         className='btn btn-block btn-disabled disabled text-uppercase'
                                                         disabled
                                                         style={{
                                                            opacity: ".7",
                                                         }}
                                                      >
                                                         {this.props.t(
                                                            "ProgramDetailTree.w_pohon"
                                                         )}{" "}
                                                         {
                                                            this.state
                                                               .selectedTreeName
                                                         }{" "}
                                                         {this.props.t(
                                                            "ProgramDetailTree.w_habis"
                                                         )}
                                                      </button>
                                                   </React.Fragment>
                                                ) : (
                                                   <React.Fragment>
                                                      {this.state
                                                         .selectedPrice *
                                                         this.state.treeQty <
                                                      9999 ? (
                                                         <React.Fragment>
                                                            <button
                                                               className='btn btn-orange btn-block btn-disabled disabled'
                                                               disabled
                                                               style={{
                                                                  opacity: ".7",
                                                               }}
                                                            >
                                                               {this.props.t(
                                                                  "ProgramDetailTree.btn_beli"
                                                               )}
                                                            </button>
                                                            <div className='text-center mt-1'>
                                                               <small className='text-red'>
                                                                  {this.props.t(
                                                                     "ProgramDetailTree.text_minimalPembelian"
                                                                  )}
                                                               </small>
                                                            </div>
                                                         </React.Fragment>
                                                      ) : (
                                                         <React.Fragment>
                                                            <div className='content-form'>
                                                               <div className='form-group'>
                                                                  <label
                                                                     className='label-group'
                                                                     htmlFor='fullname'
                                                                  >
                                                                     {t(
                                                                        "YourFullname"
                                                                     )}{" "}
                                                                     <span className='tx-red'>
                                                                        *
                                                                     </span>
                                                                  </label>
                                                                  <DebounceInput
                                                                     minLength={
                                                                        2
                                                                     }
                                                                     debounceTimeout={
                                                                        350
                                                                     }
                                                                     onChange={
                                                                        this
                                                                           .handleChangeName
                                                                     }
                                                                     autoComplete='off'
                                                                     placeholder={t(
                                                                        "TypeHere"
                                                                     )}
                                                                     className='field-group'
                                                                     id='fullname'
                                                                     value={
                                                                        this
                                                                           .state
                                                                           .fullName ||
                                                                        ""
                                                                     }
                                                                  />
                                                                  {this.state
                                                                     .fullNameValid ===
                                                                  false ? (
                                                                     <div className='tx-error'>
                                                                        {
                                                                           this
                                                                              .state
                                                                              .fullNameAlert
                                                                        }
                                                                     </div>
                                                                  ) : (
                                                                     ""
                                                                  )}
                                                               </div>
                                                               <div className='form-group'>
                                                                  <label
                                                                     className='label-group'
                                                                     htmlFor='email'
                                                                  >
                                                                     {t(
                                                                        "YourEmail"
                                                                     )}{" "}
                                                                     <span className='tx-red'>
                                                                        *
                                                                     </span>
                                                                  </label>
                                                                  <DebounceInput
                                                                     minLength={
                                                                        5
                                                                     }
                                                                     debounceTimeout={
                                                                        350
                                                                     }
                                                                     onChange={
                                                                        this
                                                                           .handleChangeEmail
                                                                     }
                                                                     autoComplete='off'
                                                                     placeholder={t(
                                                                        "TypeHere"
                                                                     )}
                                                                     className='field-group'
                                                                     id='email'
                                                                     value={
                                                                        this
                                                                           .state
                                                                           .email ||
                                                                        ""
                                                                     }
                                                                  />
                                                                  {this.state
                                                                     .emailValid ===
                                                                  false ? (
                                                                     <div className='tx-error'>
                                                                        {
                                                                           this
                                                                              .state
                                                                              .emailAlert
                                                                        }
                                                                     </div>
                                                                  ) : (
                                                                     ""
                                                                  )}
                                                               </div>
                                                               <p className='tx-note'>
                                                                  <small>
                                                                     {t(
                                                                        "YourReceiptWillBeSentTo"
                                                                     )}
                                                                  </small>
                                                               </p>
                                                            </div>
                                                         </React.Fragment>
                                                      )}
                                                   </React.Fragment>
                                                )}
                                             </div>
                                          </div>
                                       )}

                                       {/* Modal Buy Confirmation */}
                                       <div
                                          className={
                                             this.state.modalConfirmation
                                                ? "wrap-modal show"
                                                : "wrap-modal"
                                          }
                                          id='confirmation-popup'
                                       >
                                          <div
                                             className='box-close'
                                             onClick={() => {
                                                this.setState({
                                                   modalConfirmation:
                                                      !this.state
                                                         .modalConfirmation,
                                                });
                                             }}
                                          >
                                             &nbsp;
                                          </div>
                                          <div className='box-modal'>
                                             <div className='box-modal-content'>
                                                <h3 className='mt-0 mb-4 font-bold'>
                                                   {this.props.t(
                                                      "ProgramDetailTree.text_ringkasanPembelian"
                                                   )}
                                                </h3>
                                                <div className='row mb-3'>
                                                   <div className='col-4'>
                                                      <span className='text-gray text-uppercase font-semi-bold'>
                                                         {this.props.t(
                                                            "ProgramDetailTree.w_jumlah"
                                                         )}
                                                      </span>
                                                   </div>
                                                   <div className='col-8'>
                                                      <span className='font-semi-bold'>
                                                         {this.state.treeQty}{" "}
                                                         {this.props.t(
                                                            "ProgramDetailTree.w_pohon"
                                                         )}
                                                      </span>
                                                   </div>
                                                </div>
                                                <div className='row mb-3'>
                                                   <div className='col-4'>
                                                      <span className='text-gray text-uppercase font-semi-bold'>
                                                         {this.props.t(
                                                            "ProgramDetailTree.w_spesies"
                                                         )}
                                                      </span>
                                                   </div>
                                                   <div className='col-8'>
                                                      <span className='font-semi-bold text-capitalize'>
                                                         {
                                                            this.state
                                                               .selectedTreeName
                                                         }
                                                      </span>
                                                   </div>
                                                </div>
                                                <div className='row mb-3'>
                                                   <div className='col-4'>
                                                      <span className='text-gray text-uppercase font-semi-bold'>
                                                         {this.props.t(
                                                            "ProgramDetailTree.w_harga"
                                                         )}
                                                      </span>
                                                   </div>
                                                   <div className='col-8'>
                                                      <span className='tx-bold font-semi-bold'>
                                                         <NumberFormat
                                                            prefix={"Rp "}
                                                            decimalScale={0}
                                                            thousandSeparator={
                                                               ","
                                                            }
                                                            decimalSeparator={
                                                               "."
                                                            }
                                                            value={
                                                               this.state
                                                                  .selectedPrice
                                                            }
                                                            displayType='text'
                                                         />
                                                      </span>
                                                   </div>
                                                </div>
                                                {this.state
                                                   .selectedIncludeTax ? null : (
                                                   <div className='row mb-3'>
                                                      <div className='col-4'>
                                                         <span className='text-gray text-uppercase font-semi-bold'>
                                                            {this.props.t(
                                                               "ProgramDetailTree.text_ppn"
                                                            )}
                                                         </span>
                                                      </div>
                                                      <div className='col-8'>
                                                         <span className='tx-bold font-semi-bold'>
                                                            <NumberFormat
                                                               suffix={"%"}
                                                               decimalScale={0}
                                                               thousandSeparator={
                                                                  ","
                                                               }
                                                               decimalSeparator={
                                                                  "."
                                                               }
                                                               value={
                                                                  this.state
                                                                     .selectedAddedTaxPercentage
                                                               }
                                                               displayType='text'
                                                            />
                                                         </span>
                                                      </div>
                                                   </div>
                                                )}
                                                <div className='line mt-5'></div>
                                                <span>
                                                   {this.props.t(
                                                      "ProgramDetailTree.text_totalTagihan"
                                                   )}
                                                </span>
                                                <div>
                                                   {this.state
                                                      .selectedIncludeTax ? (
                                                      <h2 className='tx-orange mt-2 font-bold'>
                                                         <NumberFormat
                                                            prefix={"Rp "}
                                                            decimalScale={0}
                                                            thousandSeparator={
                                                               ","
                                                            }
                                                            decimalSeparator={
                                                               "."
                                                            }
                                                            value={
                                                               this.state
                                                                  .selectedPrice *
                                                               this.state
                                                                  .treeQty
                                                            }
                                                            displayType='text'
                                                         />
                                                      </h2>
                                                   ) : (
                                                      <h2 className='tx-orange mt-2 font-bold'>
                                                         <NumberFormat
                                                            prefix={"Rp "}
                                                            decimalScale={0}
                                                            thousandSeparator={
                                                               ","
                                                            }
                                                            decimalSeparator={
                                                               "."
                                                            }
                                                            value={
                                                               this.state
                                                                  .selectedPrice *
                                                                  this.state
                                                                     .treeQty +
                                                               (this.state
                                                                  .selectedPrice *
                                                                  this.state
                                                                     .treeQty *
                                                                  this.state
                                                                     .selectedAddedTaxPercentage) /
                                                                  100
                                                            }
                                                            displayType='text'
                                                         />
                                                      </h2>
                                                   )}
                                                </div>
                                                <br />
                                                <div className='mb-3'>
                                                   <label
                                                      htmlFor='termCondition'
                                                      className='term-condition'
                                                   >
                                                      <input
                                                         id='termCondition'
                                                         type='checkbox'
                                                         checked={
                                                            this.state.checked
                                                         }
                                                         onChange={
                                                            this
                                                               .handleCheckClick
                                                         }
                                                      />
                                                      &nbsp;{" "}
                                                      <small>
                                                         {this.props.t(
                                                            "ProgramDetailTree.label_setuju"
                                                         )}{" "}
                                                         <Link
                                                            target={"_blank"}
                                                            to='/term-conditions'
                                                         >
                                                            {this.props.t(
                                                               "ProgramDetailTree.link_syarat"
                                                            )}
                                                         </Link>
                                                      </small>
                                                   </label>
                                                </div>
                                                {this.state.loaderButton ? (
                                                   <button
                                                      className='btn btn-orange btn-block'
                                                      style={{ opacity: ".7" }}
                                                   >
                                                      <div className='loader'></div>
                                                   </button>
                                                ) : (
                                                   <React.Fragment>
                                                      {this.state.checked ? (
                                                         <button
                                                            className='btn btn-orange btn-block'
                                                            onClick={
                                                               this.orderTree
                                                            }
                                                         >
                                                            {this.props.t(
                                                               "ProgramDetailTree.btn_bayar"
                                                            )}
                                                         </button>
                                                      ) : (
                                                         <button
                                                            className='btn btn-orange btn-block'
                                                            style={{
                                                               opacity: ".7",
                                                            }}
                                                         >
                                                            {this.props.t(
                                                               "ProgramDetailTree.btn_bayar"
                                                            )}
                                                         </button>
                                                      )}
                                                   </React.Fragment>
                                                )}
                                             </div>
                                          </div>
                                       </div>
                                    </div>

                                    {/* Bottom Section */}
                                    <div className='col-sm-12'>
                                       <hr className='line-div' />
                                       <div className='program-general mt-2 mb-4'>
                                          <div className='program-detail-tab'>
                                             <Tabs>
                                                <TabList>
                                                   <Tab>
                                                      {this.props.t(
                                                         "ProgramDetailTree.text_deskripsiProgram"
                                                      )}
                                                   </Tab>
                                                </TabList>

                                                <TabPanel>
                                                   <div className='program-tab-description mt-4'>
                                                      <div
                                                         dangerouslySetInnerHTML={{
                                                            __html:
                                                               data.description,
                                                         }}
                                                      />
                                                      <br />
                                                   </div>
                                                   <br />
                                                   <div className='wrap-relative'>
                                                      <h3>
                                                         {this.props.t(
                                                            "ProgramDetailTree.text_lokasiProgram"
                                                         )}
                                                      </h3>
                                                      <Map
                                                         google={
                                                            this.props.google
                                                         }
                                                         className={"map"}
                                                         onReady={(
                                                            mapProps,
                                                            map
                                                         ) =>
                                                            this._mapLoaded(
                                                               mapProps,
                                                               map
                                                            )
                                                         }
                                                         bounds={
                                                            this.state.bounds
                                                         }
                                                         onClick={
                                                            this.onMapClicked
                                                         }
                                                      >
                                                         <Polygon
                                                            paths={
                                                               this.state
                                                                  .program
                                                                  .blockPolygon
                                                            }
                                                            strokeColor='#0000FF'
                                                            strokeOpacity={0.8}
                                                            strokeWeight={2}
                                                            fillColor='#0000FF'
                                                            fillOpacity={0.1}
                                                            blockLocationName={
                                                               this.state
                                                                  .program
                                                                  .blockLocationName
                                                            }
                                                            area={
                                                               this.state
                                                                  .program.area
                                                            }
                                                            fillOpacity={0.1}
                                                            onClick={
                                                               this
                                                                  .onPolygonClicked
                                                            }
                                                         />
                                                         <InfoWindow
                                                            marker={
                                                               this.state
                                                                  .activeMarker
                                                            }
                                                            position={
                                                               this.state.bounds
                                                            }
                                                            onOpen={
                                                               this
                                                                  .onInfoWindowOpen
                                                            }
                                                            onClose={
                                                               this
                                                                  .onInfoWindowClose
                                                            }
                                                            visible={
                                                               this.state
                                                                  .showingInfoWindow
                                                            }
                                                         >
                                                            <div>
                                                               <b>
                                                                  {
                                                                     this.state
                                                                        .selectedPlace
                                                                        .blockLocationName
                                                                  }
                                                               </b>
                                                               <p>
                                                                  <NumberFormat
                                                                     value={
                                                                        this
                                                                           .state
                                                                           .selectedPlace
                                                                           .area
                                                                     }
                                                                     displayType={
                                                                        "text"
                                                                     }
                                                                     thousandSeparator={
                                                                        true
                                                                     }
                                                                     decimalScale={
                                                                        0
                                                                     }
                                                                  />{" "}
                                                                  &nbsp; Hectare
                                                               </p>
                                                            </div>
                                                         </InfoWindow>
                                                      </Map>
                                                   </div>
                                                   <br />
                                                   <br />
                                                   <br />
                                                   <h3>
                                                      {this.props.t(
                                                         "ProgramDetailTree.text_daftarSpesiesPohon"
                                                      )}
                                                   </h3>
                                                   <div
                                                      style={{
                                                         overflowX: "scroll",
                                                         paddingBottom: "10px",
                                                      }}
                                                   >
                                                      <div
                                                         style={{
                                                            minWidth: "680px",
                                                         }}
                                                      >
                                                         <div className='tb-header'>
                                                            <div className='tbr-flex'>
                                                               <div className='tbc-flex'>
                                                                  {this.props.t(
                                                                     "ProgramDetailTree.text_namaPohon"
                                                                  )}
                                                               </div>
                                                               <div className='tbc-flex'>
                                                                  {this.props.t(
                                                                     "ProgramDetailTree.text_namaLatin"
                                                                  )}
                                                               </div>
                                                               <div className='tbc-flex'>
                                                                  {this.props.t(
                                                                     "ProgramDetailTree.text_jumlahPohon"
                                                                  )}
                                                               </div>
                                                               <div className='tbc-flex'>
                                                                  {this.props.t(
                                                                     "ProgramDetailTree.w_tersedia"
                                                                  )}
                                                               </div>
                                                               <div className='tbc-flex'>
                                                                  {this.props.t(
                                                                     "ProgramDetailTree.w_harga"
                                                                  )}
                                                               </div>
                                                            </div>
                                                         </div>
                                                         <div className='tb-body'>
                                                            {data.treeSummaries.map(
                                                               (
                                                                  item,
                                                                  index
                                                               ) => (
                                                                  <div
                                                                     className='tbr-flex'
                                                                     key={index}
                                                                  >
                                                                     <div className='tbc-flex'>
                                                                        <span className='text-capitalize'>
                                                                           {
                                                                              item.treeName
                                                                           }
                                                                        </span>
                                                                     </div>
                                                                     <div className='tbc-flex'>
                                                                        <span className='text-capitalize'>
                                                                           {
                                                                              item.treeBinomialName
                                                                           }
                                                                        </span>
                                                                     </div>
                                                                     <div className='tbc-flex'>
                                                                        {
                                                                           item.total
                                                                        }
                                                                     </div>
                                                                     <div className='tbc-flex'>
                                                                        {
                                                                           item.available
                                                                        }
                                                                     </div>
                                                                     <div className='tbc-flex text-orange'>
                                                                        Rp{" "}
                                                                        <NumberFormat
                                                                           value={
                                                                              item.sellingPrice
                                                                           }
                                                                           displayType={
                                                                              "text"
                                                                           }
                                                                           decimalScale={
                                                                              0
                                                                           }
                                                                           thousandSeparator={
                                                                              ","
                                                                           }
                                                                           decimalSeparator={
                                                                              "."
                                                                           }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               )
                                                            )}
                                                         </div>
                                                      </div>
                                                   </div>
                                                </TabPanel>
                                             </Tabs>
                                             <br />
                                          </div>
                                       </div>
                                       <br />
                                    </div>
                                 </div>
                              </div>
                              <div className='footer-payment'>
                                 {/* {buttonPayment} */}
                                 <div className='text-center'>
                                    <a
                                       href='https://play.google.com/store/apps/details?id=com.jejakin.app'
                                       target='_blank'
                                       className='link-block w-inline-block'
                                       rel='noopener noreferrer'
                                    >
                                       <img
                                          src='https://uploads-ssl.webflow.com/6234410e7a06db05e25d6a01/6239948ff4c05744613c30b4_googleplay.png'
                                          loading='lazy'
                                          height='51'
                                          alt='Google Play Button'
                                          className='image-2'
                                       />
                                    </a>
                                    &nbsp;
                                    <a
                                       href='https://apps.apple.com/id/app/jejakinapp/id1620855944'
                                       target='_blank'
                                       className='link-block w-inline-block'
                                       rel='noopener noreferrer'
                                    >
                                       <img
                                          src='https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg'
                                          loading='lazy'
                                          height='51'
                                          alt='App Store Button'
                                          className='image-2'
                                       />
                                    </a>
                                 </div>
                              </div>
                           </>
                        )}
                     </Translation>
                  </Suspense>
               </div>
            )}
         </div>
      );
   }
}

export default withTranslation()(
   GoogleApiWrapper({
      apiKey: "AIzaSyCS9mdO4o_M7sv8ONF9Ft0CQaWoGuk6Ay8",
   })(ProgramDetailTree)
);
